var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cont"},[_c('div',{staticClass:"bgcBox"},[_c('div',{staticClass:"listBox"},[_c('div',{staticClass:"tittle"},[_vm._v(_vm._s(_vm.detail.title))]),_c('div',{staticClass:"time"},[_vm._v("日期："+_vm._s(_vm.detail.addtime))]),_c('div',{staticClass:"contentT",domProps:{"innerHTML":_vm._s(_vm.detail.content)}})])])])
}
var staticRenderFns = []

export { render, staticRenderFns }